import axios from 'axios'

/**
 * Creates axios instance when needed
 * @param params {Object} - Set of default axios parameters
 */
export default function createAxios(params) {
    return axios.create(params)
}